import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import { useEffect, useState } from 'react';
import { getRhumbLineBearing } from 'geolib';
import { STATIC_IMAGES } from '../../../app.config.vars/staticImages';
import { useDeviceOrientation } from '../../../hooks/deviceOrientation';
import InfoBox from '../../../ui/InfoBox';
import { useTranslation } from 'react-i18next';
import { getDistance } from '../../../helpers';
const CompassNavigation = ({ targetLocation, userPosition }) => {
    const { i18n, t } = useTranslation();
    const [bearingToTarget, setBearingToTarget] = useState(0);
    const { heading } = useDeviceOrientation();
    const distance = getDistance(userPosition, targetLocation);
    const relativeAngle = (bearingToTarget - (heading ?? 0) + 360) % 360;
    useEffect(() => {
        const bearing = getRhumbLineBearing(userPosition, targetLocation);
        setBearingToTarget(bearing);
    }, [userPosition, targetLocation]);
    return (_jsxs("div", { className: "compass-container", children: [_jsxs("div", { className: "compass", children: [_jsx("img", { src: i18n.language === 'de'
                            ? localStorage.getItem(STATIC_IMAGES.compassDe.key) || undefined
                            : localStorage.getItem(STATIC_IMAGES.compassEn.key) || undefined, alt: "Compass", className: "compass-bg-image", style: {
                            transform: `translate(-50%, -50%) rotate(${heading ?? 0}deg)`,
                            transformOrigin: '50% 50%',
                        } }), _jsx("img", { src: localStorage.getItem(STATIC_IMAGES.compassArrow.key) || undefined, alt: "Arrow", className: "compass-arrow", style: {
                            transform: `translate(-50%, -50%) rotate(${relativeAngle}deg)`,
                            transformOrigin: '50% 50%',
                        } })] }), _jsx("div", { className: 'distance', children: _jsx(InfoBox, { textContent: i18n.language === 'de'
                        ? `${t('label.left')} ${distance.toFixed(2)} m`
                        : `${distance.toFixed(2)} m ${t('label.left')}`, backgroundColor: '#f39200' }) })] }));
};
export default CompassNavigation;
